// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"0359eb3e","189":"b54fc025","200":"6b80827b","271":"6f2efc9a","283":"3c7d35ad","353":"e992d0d2","381":"eb7d3743","387":"958d8c85","396":"a1ed283d","663":"e291da90","722":"8688ed51","760":"80524e93","762":"2520fe75","830":"2ba4f87b","904":"6f3e8149","985":"580dee1e"}[chunkId] + ".chunk.js";
};